import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { SessionActions } from '../../store/session/session.actions';
import { LoadingActions } from 'src/app/core/store/loading/loading.actions';
import type { Entity } from '../../../core/models/entity.model';
import type { EntityEditorPropertyChangedEvent } from '../../../entity-editor/models/entity-editor-property-changed.event';
import { FormGroup, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  standalone: false
})
export class LoginFormComponent {
  @Input() loginEntity: Entity;

  @Output() submitForm = new EventEmitter<void>();

  protected loginForm: UntypedFormGroup;

  constructor(private store: Store) {
    this.loginForm = new FormGroup({});
  }

  propertyChanged($event: EntityEditorPropertyChangedEvent) {
    if ($event.propertyKey === 'LoginButton') {
      this.store.dispatch(LoadingActions.loading_end());
      this.loginForm.updateValueAndValidity({ emitEvent: false });
      if (this.loginForm.valid) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { LoginButton, ...userLoginData } = this.loginForm.value;
        this.store.dispatch(SessionActions.login_start({ userLoginData }));
      } else {
        this.loginForm.markAllAsTouched();
      }
    }
  }
}
